
import { defineComponent } from 'vue'

import { RouteNavigationParams } from '~/utils/router'

import { AgentKind } from '~/types/types'

export interface LinkOptions {
  id: AgentKind
  name: string
  label: string
  icon: string
  route: RouteNavigationParams
  isBeta?: boolean
}

export default defineComponent({
  name: 'AgentNavSidebar',
  props: {
    showMemories: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    agentsOptions(): LinkOptions[] {
      return [
        {
          id: AgentKind.FpTriage,
          name: 'orgs-provider-owner-agents-false-positive-triage',
          label: 'False Positive Triage',
          icon: 'false-positive',
          route: {
            name: 'orgs-provider-owner-agents-agentKind',
            params: { ...this.$route.params, agentKind: 'false-positive-triage' }
          }
        },
        {
          id: AgentKind.CvePrioritization,
          name: 'orgs-provider-owner-agents-cve-prioritization',
          label: 'CVE Prioritization',
          icon: 'cve-prioritisation',
          route: {
            name: 'orgs-provider-owner-agents-agentKind',
            params: { ...this.$route.params, agentKind: 'cve-prioritization' }
          }
        },
        {
          id: AgentKind.AutofixAutopilot,
          name: 'orgs-provider-owner-agents-autofix-autopilot',
          label: 'Autofix™ Autopilot',
          icon: 'autofix',
          route: {
            name: 'orgs-provider-owner-agents-agentKind',
            params: { ...this.$route.params, agentKind: 'autofix-autopilot' }
          }
        }
      ]
    }
  },
  methods: {
    isActive(option: LinkOptions): boolean {
      if (this.$route.name !== 'orgs-provider-owner-agents-agentKind') {
        return false
      }
      return this.$route.params.agentKind === option.route.params?.agentKind
    }
  }
})
